import { useEffect, useRef } from 'react'
import { useLocation } from 'wouter'
import { api } from '../lib/api'

function eventId(): string {
  return crypto.randomUUID()
}

export function AnalyticsTracker() {
  const [location] = useLocation()
  const trackedPath = useRef('')
  const interacted = useRef(false)

  useEffect(() => {
    const path = window.location.pathname || '/'
    const isNewNavigation = trackedPath.current !== path
    if (isNewNavigation) {
      trackedPath.current = path
      interacted.current = false
      const search = new URLSearchParams(window.location.search)
      const common = {
        path,
        referrer: document.referrer,
        utm_source: search.get('utm_source') || '',
        utm_medium: search.get('utm_medium') || '',
        utm_campaign: search.get('utm_campaign') || '',
      }
      void api.captureAnalytics({
        ...common,
        event_id: eventId(),
        event_type: 'page_view',
      }).catch(() => undefined)
      if (path === '/chat') {
        void api.captureAnalytics({
          ...common,
          event_id: eventId(),
          event_type: 'chat_opened',
        }).catch(() => undefined)
      }
    }

    const markInteraction = () => { interacted.current = true }
    window.addEventListener('pointerdown', markInteraction, { passive: true })
    window.addEventListener('keydown', markInteraction, { passive: true })
    window.addEventListener('scroll', markInteraction, { passive: true })
    const started = performance.now()
    const timer = window.setTimeout(() => {
      void api.captureAnalytics({
        event_id: eventId(),
        event_type: 'engaged_visit',
        path,
        referrer: document.referrer,
        duration_ms: Math.round(performance.now() - started),
        visible: document.visibilityState === 'visible',
        interacted: interacted.current,
      }).catch(() => undefined)
    }, 10_000)

    return () => {
      window.clearTimeout(timer)
      window.removeEventListener('pointerdown', markInteraction)
      window.removeEventListener('keydown', markInteraction)
      window.removeEventListener('scroll', markInteraction)
    }
  }, [location])

  return null
}
